export const ReadingBookList = ({userReport=null}) => {
  
    if(!userReport)return null;

  if( null===userReport.books )return <tr><td colSpan="12" className="no_data"><p>목록이 없습니다.</p></td></tr>;
        let sum = {apple:0, quiz:0, report:0, picture:0, photo:0, video:0, meeting:0, userbook:0};
        let rowList = userReport.books.map( (book, key)=>{
            sum.apple += book.apple;
            sum.quiz += book.quiz;
            sum.report += book.report;
            sum.picture += book.picture;
            sum.photo += book.photo;
            sum.video += book.video;
            sum.meeting += book.meeting;
            sum.userbook += book.userbook;
            
            return (
                <tr className="text-center" key={key}>
                    <td>{key+1}</td>
                    <td>{book.title}</td>
                    <td>{book.author}</td>
                    <td>{book.publisher}</td>
                    <td>{book.apple}</td>
                    <td>{book.quiz}</td>
                    <td>{book.report}</td>
                    <td>{book.picture}</td>
                    <td>{book.photo}</td>
                    <td>{book.video}</td>
                    <td>{book.meeting}</td>
                    <td>{book.userbook}</td>
                </tr>
            )
        });


        rowList.push(
            <tr className="text-center" key="sum">
                    <td colSpan="4" >합계</td>
                    <td>{sum.apple}</td>
                    <td>{sum.quiz}</td>
                    <td>{sum.report}</td>
                    <td>{sum.picture}</td>
                    <td>{sum.photo}</td>
                    <td>{sum.video}</td>
                    <td>{sum.meeting}</td>
                    <td>{sum.userbook}</td>
                </tr>
        )


        return rowList;
};